import {
  accessTokenStatusBadge,
  agentTypeBadge,
  agentTypeIconClass,
  issuePriorityBadge,
  issueStatusBadge,
  issueStatusFilterDefs,
  reviewResultBadge,
  timelineActionLabel,
  timelineActionMeta,
} from './lib/status-ui';
import { escapeHtml } from './lib/html';

/**
 * SkillFab Shared Utilities
 * Common functions used across multiple pages
 */
(function() {
  'use strict';

  window.escapeHtml = escapeHtml;

  window.issuePriorityBadge = issuePriorityBadge;
  window.issueStatusBadge = issueStatusBadge;
  window.issueStatusFilterDefs = issueStatusFilterDefs;
  window.agentTypeBadge = agentTypeBadge;
  window.agentTypeIconClass = agentTypeIconClass;
  window.accessTokenStatusBadge = accessTokenStatusBadge;
  window.reviewResultBadge = reviewResultBadge;
  window.timelineActionMeta = timelineActionMeta;
  window.timelineActionLabel = timelineActionLabel;
})();
